import { QueryClient } from "@tanstack/react-query";
import { cache } from "react";

// CRITICAL: Use same config as ReactQueryProvider to prevent "No QueryClient set" error
const getQueryClient = cache(() => new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 10, // 10 minutes
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
      retry: (failureCount, error: any) =>
        error?.response?.status !== 400 && failureCount < 3,
    },
  },
}));

export default getQueryClient;